/**
 * @Author : DingHuiHui
 * @Content : 业务日志
 */
import $http from '@/utils/requestAxios'

// 日志
export const apiBLog = {
  // 列表
  list (params, page = 1, size = 10) {
    return $http.get('/buslogs', { ...params, page, size })
  },
  // 删除
  delete (id) {
    return $http.delete(`/buslogs/${id}`)
  },
  // 导出
  export (viewId) {
    return $http.get(`/buslogs/export/${viewId}`)
  }
}

// 视图
export const apiView = {
  // 列表
  list (viewName, viewModule = 'business_log', page = 1, size = 10000) {
    return $http.get('/esview', { viewName, viewModule, page, size })
  },
  // 新增
  add (viewName, fields, viewModule = 'business_log', viewTime = new Date(), viewParamId = 0) {
    return $http.post('/esview', { viewName, fields, viewModule, viewTime, viewParamId })
  },
  // 修改
  edit (id, fields, viewModule = 'business_log', viewTime = new Date()) {
    return $http.put('/esview', { id, fields, viewModule, viewTime })
  },
  // 删除
  del (ids) {
    return $http.delete(`/esview/${ids}`)
  }
}
